import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import type LessonInfoService from 'teacher-ui-client/services/lesson-info'

export default class extends Route {
  @service lessonInfo!: LessonInfoService

  async beforeModel() {
    const precincts = [Precinct.RE_READING, Precinct.RE_SPELLING, Precinct.RE_STORYLANDS, Precinct.RE_DRIVING_TESTS]

    await this.lessonInfo.loadLessonInfoFor(precincts)
  }

  model() {
    return {
      product: 're',
    }
  }
}
